var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditorAddFreeAnswer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1181_1861)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 3.8335H15C15.442 3.8335 15.866 4.00909 16.1785 4.32165C16.4911 4.63421 16.6667 5.05814 16.6667 5.50016V17.1668C16.6667 17.6089 16.4911 18.0328 16.1785 18.3453C15.866 18.6579 15.442 18.8335 15 18.8335H5.00001C4.55798 18.8335 4.13406 18.6579 3.8215 18.3453C3.50894 18.0328 3.33334 17.6089 3.33334 17.1668V5.50016C3.33334 5.05814 3.50894 4.63421 3.8215 4.32165C4.13406 4.00909 4.55798 3.8335 5.00001 3.8335H6.66668",
    stroke: "#98BDBD",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2.1665H7.49999C7.03975 2.1665 6.66666 2.5396 6.66666 2.99984V4.6665C6.66666 5.12674 7.03975 5.49984 7.49999 5.49984H12.5C12.9602 5.49984 13.3333 5.12674 13.3333 4.6665V2.99984C13.3333 2.5396 12.9602 2.1665 12.5 2.1665Z",
    stroke: "#98BDBD",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 9.5H13.5",
    stroke: "#98BDBD",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 12H13.5",
    stroke: "#98BDBD",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 14.5H13.5",
    stroke: "#98BDBD",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1181_1861"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(20 0.5) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditorAddFreeAnswer);
export default __webpack_public_path__ + "static/media/editor_add_free_answer.4096264bc7d5ef768eac7aefbf41db26.svg";
export { ForwardRef as ReactComponent };